import {
  EmptyPageWrapper,
  EmptyPageHeading,
  EmptyPageMessage,
} from './EmptyIdentificationRequests.styles';

type IEmptyFile = {
  title: string;
  message: string;
};

const EmptyIdentificationRequests = ({ title, message }: IEmptyFile) => {
  return (
    <EmptyPageWrapper>
      <EmptyPageHeading>{title}</EmptyPageHeading>
      {message && <EmptyPageMessage>{message} </EmptyPageMessage>}
    </EmptyPageWrapper>
  );
};

export { EmptyIdentificationRequests };
